export default __webpack_public_path__ + "static/media/sem-foto.85bc1e0d.jpg";